import { Elements } from "@stripe/react-stripe-js";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import { ErrorBoundary } from "./lib/components/errors/ErrorBoundary";
import { QueryClientProvider } from "./lib/context/query-client";
import { ThemeProvider } from "./lib/context/theme-provider";
import { stripePromise } from "./lib/utils/stripe";
import router from "./pages/app";
import "./globals.css";
import "./lib/i18n";

// Root element
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

// App
const app = (
	<StrictMode>
		<ErrorBoundary>
			<QueryClientProvider>
				<ThemeProvider defaultTheme="dark" storageKey="theme">
					<Elements stripe={stripePromise}>
						<RouterProvider router={router} />
						<Toaster position="bottom-right" />
					</Elements>
				</ThemeProvider>
			</QueryClientProvider>
		</ErrorBoundary>
	</StrictMode>
);

// Hot module replacement
if (import.meta.hot) {
	if (!import.meta.hot.data.root) {
		import.meta.hot.data.root = createRoot(rootElement);
	}
	const root = import.meta.hot.data.root;
	root.render(app);
} else {
	const root = createRoot(rootElement);
	root.render(app);
}

// Service Worker Registration
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker
			.register("/sw.js")
			.then((reg) => console.log("SW registered:", reg))
			.catch((err) => console.error("SW registration failed:", err));
	});
}
